import React from 'react'
import PropTypes from 'prop-types'

import { RichContent } from './Content'

const QuestionAnswerCard = ({ name, answer }) => (
  <div className="m-2">
    <span className="text-green-900 font-bold m-2">{name}</span>
    <RichContent content={answer} className="bg-green-100 border-green-600 p-4 m-2 rounded" />
  </div>
)

QuestionAnswerCard.propTypes = {
  name: PropTypes.string.isRequired,
  answer: PropTypes.shape({
    raw: PropTypes.string.isRequired
  }).isRequired
}

export default QuestionAnswerCard
